export function checkRequire(form) {
	let is_valid = true;
	Array.from(form.elements).forEach((element) => {
		if (!element.checkValidity()) {
			if (is_valid) {
				element.scrollIntoView({ behavior: "smooth" });
				element.classList.add("invalid");
				element.reportValidity();
			}
			is_valid = false;
		}
	});

	if (!is_valid) return false;
	return true;
}